module.exports = __webpack_public_path__ + "static/media/fav.0e8624ec.png";